/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategorySuggestionRequest
 */
export interface CategorySuggestionRequest {
    /**
     * 
     * @type {string}
     * @memberof CategorySuggestionRequest
     */
    headline: string;
    /**
     * 
     * @type {string}
     * @memberof CategorySuggestionRequest
     */
    vertical?: CategorySuggestionRequestVerticalEnum;
}


/**
 * @export
 */
export const CategorySuggestionRequestVerticalEnum = {
    Freelancer: 'FREELANCER',
    Strategy: 'STRATEGY'
} as const;
export type CategorySuggestionRequestVerticalEnum = typeof CategorySuggestionRequestVerticalEnum[keyof typeof CategorySuggestionRequestVerticalEnum];


/**
 * Check if a given object implements the CategorySuggestionRequest interface.
 */
export function instanceOfCategorySuggestionRequest(value: object): value is CategorySuggestionRequest {
    if (!('headline' in value) || value['headline'] === undefined) return false;
    return true;
}

export function CategorySuggestionRequestFromJSON(json: any): CategorySuggestionRequest {
    return CategorySuggestionRequestFromJSONTyped(json, false);
}

export function CategorySuggestionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategorySuggestionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'headline': json['headline'],
        'vertical': json['vertical'] == null ? undefined : json['vertical'],
    };
}

export function CategorySuggestionRequestToJSON(value?: CategorySuggestionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'headline': value['headline'],
        'vertical': value['vertical'],
    };
}

